// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { min as fn } from "../min.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const minWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default minWithOptions;
